module.exports = __webpack_public_path__ + "img/20191218154239813.9be8489a.jpg";